import { BACKEND_URL } from "../config/env";

const SOCKET_IO_SUFFIX = "/socket.io";

const buildSocketPath = pathname => {
  const normalizedPath = pathname && pathname !== "/" ? pathname.replace(/\/$/, "") : "";
  return `${normalizedPath}${SOCKET_IO_SUFFIX}`;
};

export const getSocketConnectionConfig = (namespace = "") => {
  const normalizedNamespace = namespace
    ? namespace.startsWith("/")
      ? namespace
      : `/${namespace}`
    : "";

  try {
    const parsedUrl = new URL(BACKEND_URL);

    return {
      socketUrl: `${parsedUrl.origin}${normalizedNamespace}`,
      socketPath: buildSocketPath(parsedUrl.pathname)
    };
  } catch (_error) {
    return {
      socketUrl: `${BACKEND_URL}${normalizedNamespace}`,
      socketPath: SOCKET_IO_SUFFIX
    };
  }
};
